// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application'

import ElementController from './element_controller'
import TooltipController from './tooltip_controller'
import TabsController from './tabs_controller'
import ScrollTopController from './scroll_top_controller'
import UploadFileController from './upload_file_controller'
import AutoSubmitController from './auto_submit_contoller'
import CollapseController from './collapse_controller'
import ChartController from './chart_controller'
import AsyncSelectController from './async_select_controller'
import RetryController from './retry_controller'
import HighlightSearchMatchController from './highlight_search_match_controller'

application.register('element', ElementController)
application.register('tooltip', TooltipController)
application.register('tabs', TabsController)
application.register('collapse', CollapseController)
application.register('scroll-top', ScrollTopController)
application.register('upload-file', UploadFileController)
application.register('auto-submit', AutoSubmitController)
application.register('chart', ChartController)
application.register('async-select', AsyncSelectController)
application.register('retry', RetryController)
application.register('highlight-search-match', HighlightSearchMatchController)
